export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      documents: "Documents Sécurisés",
      telecom: "Télécom & Traçabilité",
      finance: "Marchés & Financement",
      contact: "Contact",
      contactCta: "Nous contacter",
    },
    hero: {
      eyebrow: "Identité — Traçabilité — Souveraineté",
      title1: "L'identité et la traçabilité,",
      title2: "piliers de la souveraineté nationale.",
      subtitle:
        "Plus de deux décennies aux côtés des États et des régulateurs pour concevoir, sécuriser et opérer les infrastructures d'identification et de traçabilité — dans plus d'une douzaine de pays, majoritairement sur le continent africain.",
      stat1: "20+ ans d'expérience",
      stat2: "12+ pays d'intervention",
      stat3: "50+ ans d'expertise cumulée",
      cta1: "Découvrir nos activités",
      cta2: "Nous contacter",
    },
    about: {
      eyebrow: "Profil",
      title: "Un partenaire discret des États depuis plus de 20 ans.",
      p1:
        "Fondée au début des années 2000, CIDES Invest & Trade Ltd conçoit, sécurise et déploie des solutions d'identification et de documents officiels pour le compte d'États et d'administrations publiques.",
      p2:
        "Forte d'une équipe dont l'expérience cumulée dépasse 50 années dans le secteur, CIDES a mené à bien des projets dans plus d'une douzaine de pays, avec une présence historique particulièrement forte sur le continent africain.",
      p3:
        "Notre expertise s'étend aujourd'hui de la production de documents d'identité biométriques à la certification des revenus télécom et à la souveraineté numérique des régulateurs — deux volets complémentaires d'une même mission : garantir à nos partenaires étatiques un contrôle total, fiable et auditable sur leurs données critiques.",
      quote:
        "CIDES Invest a démontré ses connaissances et sa réussite dans les dossiers clés d'applications pour les solutions d'identification.",
      pillar1Title: "Confidentialité",
      pillar1Desc: "Opérations menées avec la discrétion attendue par les États souverains.",
      pillar2Title: "Souveraineté",
      pillar2Desc: "Solutions installées et maintenues dans le pays, sans dépendance étrangère.",
      pillar3Title: "Rigueur",
      pillar3Desc: "Auditabilité totale, du niveau agrégé jusqu'à la transaction unitaire.",
    },
    documents: {
      eyebrow: "Documents Sécurisés — Technologie & Solutions",
      title: "Conception, production et intégration de documents officiels sécurisés.",
      intro:
        "L'adoption d'un système moderne d'identification apporte des avantages concrets et mesurables à toute administration.",
      benefitsTitle: "Avantages pour l'administration",
      benefits: [
        "Des documents de qualité, sécurisés et infalsifiables",
        "Un système moderne, aligné sur les standards des administrations comparables",
        "Un contrôle renforcé de la délivrance de chaque document, pour empêcher la fraude",
        "Une base de données fiable et flexible, permettant une recherche immédiate et précise",
        "Des statistiques éditées en temps réel, par catégorie ou par thème",
        "Une réduction significative de la manipulation physique des documents",
        "Une gestion précise des stocks et des recettes générées par la délivrance",
        "La possibilité, à terme, de connecter la base de données à d'autres administrations ou ministères",
        "Une architecture évolutive, extensible à d'autres applications ou documents selon les besoins futurs",
        "Un facteur reconnu d'amélioration dans l'évaluation de la performance publique",
      ],
      methodTitle: "Notre méthodologie",
      methodLead: "Un processus éprouvé, en six étapes.",
      method: [
        { t: "Acquisition de données", d: "Cadrage réglementaire et collecte des sources primaires." },
        { t: "Recrutement / Enrôlement", d: "Enrôlement biométrique et administratif des citoyens ou usagers." },
        { t: "Vérification", d: "Contrôles croisés et validation d'identité multi-critères." },
        { t: "Suppression des doublons", d: "Déduplication biométrique (1:N) sur l'ensemble du registre." },
        { t: "Personnalisation", d: "Personnalisation sécurisée des supports (laser, encre, puce)." },
        { t: "Délivrance", d: "Chaîne de délivrance tracée, avec sécurisation logistique et financière." },
      ],
      supportTitle: "Un accompagnement complet",
      supportDesc:
        "Nous accompagnons chaque projet avec de la formation, de la maintenance, du support continu, ainsi que des services de consultation à toutes les étapes du processus.",
      rangeTitle: "Notre gamme",
      range: {
        cards: {
          title: "Cartes",
          items: [
            "Cartes d'Identité Nationale",
            "Cartes de Résidents",
            "Permis de conduire",
            "Cartes de vote",
            "Cartes d'assurance",
            "Badges d'identification (ID Badges)",
          ],
        },
        passports: {
          title: "Passeports",
          items: ["Compatibles ICAO", "Biométriques", "Lisibles à la machine (MRZ)"],
        },
        secure: {
          title: "Documents Sécurisés",
          items: ["Chèques", "Documents fiscaux / timbres", "Visas", "Timbres-poste"],
        },
      },
      productsTitle: "Illustrations",
      specimenNote: "Les visuels affichés sont des spécimens — mention conservée par intégrité et gage de sérieux.",
      p1: { title: "Passeports biométriques", tag: "Ordinaires · Service · Diplomatiques" },
      p2: { title: "Cartes nationales d'identité", tag: "CNI · Résidents · Cartes techniques" },
      p3: { title: "Visas d'entrée", tag: "Vignettes · e-Visa · Postes frontière" },
      p4: { title: "Timbres fiscaux", tag: "Fiscalité · Tabac · Boissons" },
      p5: { title: "Permis de conduire biométriques", tag: "Format ID-1 · Personnalisation centralisée" },
      p6: { title: "Documents fiduciaires additionnels", tag: "État civil · Cartes professionnelles" },
    },
    telecom: {
      eyebrow: "Télécom & Traçabilité — Revenue Assurance",
      title: "Big Data & Revenue Assurance pour régulateurs télécom.",
      subtitle:
        "Solution de Big Data et Revenue Assurance — Télécom, Banques, Mobile Money et Betting.",
      lead:
        "Aussi essentielle que l'identité sécurisée, la souveraineté numérique passe aujourd'hui par la maîtrise des données télécom. En partenariat avec Snype, CIDES déploie des solutions de Big Data et Revenue Assurance qui donnent aux régulateurs un accès direct, factuel et auditable à leurs données télécom, financières et numériques.",
      partnerBadge: "En partenariat avec Snype",
      capabilitiesTitle: "Ce que la solution permet au régulateur",
      capabilities: [
        "Analyse du parc abonnés, vérification de l'identification et du KYC",
        "Analyse des usages Voix, SMS et Data",
        "Analyse de la QoS 2G/3G/4G/5G et de la couverture radio",
        "Certification des revenus Prépayé/Postpayé et des taxes applicables (TVA, accise, micro-taxes)",
        "Vérification des tarifs réellement appliqués",
        "Certification des volumes d'interconnexion et taxes associées",
        "Certification des revenus et coûts du Roaming",
        "Certification des revenus Mobile Money (y compris marchands)",
        "Détection de fraudes (contournement d'interconnexion, SimBox, escroqueries)",
        "Analyse des revenus des grands acteurs internet (OTT) et taxation associée",
        "Contrôle des terminaux, droits de douane, Central EIR",
        "Système centralisé pour les réquisitions judiciaires",
      ],
      extension:
        "Extensions possibles : activités bancaires et contrôle des changes, déclarations fiscales d'entreprises, activités de paris en ligne.",
      modulesTitle: "13 modules, une seule plateforme",
      modules: [
        {
          key: "core",
          name: "Core",
          desc: "Socle technique et orchestration temps-réel.",
          long:
            "Base de la solution. Permet de gérer la collecte et le traitement des fichiers, la base de données, l'archivage et tous les outils de documentation, supervision, configuration, gestion des droits d'accès.",
        },
        {
          key: "subs",
          name: "Parc Abonnés",
          desc: "Cartographie et vérification KYC du parc.",
          long:
            "Analyse du parc (parc brut, activations, résiliations), parc fonctionnel (utilisateurs vraiment actifs), avec la localisation géographique et les parts de marché. Vérification de la bonne identification des abonnés. Contrôle des fraudes sur les fausses pièces d'identité. Calcul des amendes. Suspension automatique des lignes concernées.",
        },
        {
          key: "usage",
          name: "Usage Voix / SMS / Data",
          desc: "Mesure et attribution des usages par abonné.",
          long:
            "Analyse des usages Voix, SMS et Data, ainsi que des parcs utilisateurs et parts de marché par opérateur, région par région. Possibilité d'affiner par destination et par numéro court. Détecte automatiquement les nouvelles cellules et les nouveaux terminaux, et vérifie la cohérence des informations transmises par les opérateurs. Ces données de référence servent ensuite de base aux analyses géographiques et à la comparaison avec les usages valorisés prépayés, postpayés et roaming.",
        },
        {
          key: "fraud",
          name: "Détection de Fraudes",
          desc: "SimBox, contournement d'interconnexion, escroqueries.",
          long:
            "Détection des tentatives d'escroquerie et de contournement des interconnexions. Intégration avec les opérateurs pour suspension immédiate. Intégration avec le CEIR pour blocage des terminaux. Localisation des fraudeurs.",
        },
        {
          key: "inter",
          name: "Interconnexion Voix / SMS",
          desc: "Certification des volumes et taxes associées.",
          long:
            "Analyse des interconnexions entrante/sortante, nationale/internationale, pour chaque carrier international. Détection des incidents. Valorisation des taxes applicables. Contrôle de la cohérence des données entre opérateurs, en vérifiant que ce qui sort de l'un entre effectivement bien dans l'autre.",
        },
        {
          key: "ott",
          name: "OTT",
          desc: "Revenus des acteurs internet et taxation associée.",
          long:
            "Analyse des usages data pour reconstruire les parcs utilisateurs des acteurs majeurs de l'internet (Netflix, Facebook, Google), afin d'estimer leurs revenus et de les amener à régler les taxes dues (impôts sur les sociétés, droits d'accise, TVA) sur la base d'éléments factuels.",
        },
        {
          key: "qos",
          name: "QoS",
          desc: "Qualité de service 2G/3G/4G/5G et couverture radio.",
          long:
            "Suivi du déploiement des antennes 2G/3G/4G/5G et estimation de la couverture radio, comparée aux cartes déclarées par les opérateurs. Identification des zones blanches et des zones à cibler pour les drive tests. Analyse de la performance des antennes et des connexions data, identification et qualification des incidents.",
        },
        {
          key: "ceir",
          name: "Terminaux & CEIR",
          desc: "Contrôle des terminaux, droits de douane, Central EIR.",
          long:
            "Analyse des parcs de terminaux, localisation des terminaux volés, non homologués ou non conformes. Identification précise des utilisateurs et du lieu de première utilisation. Synchronisation des EIR des opérateurs, vérification du blocage effectif, interface avec le système des douanes pour identifier les terminaux non taxés.",
        },
        {
          key: "rev",
          name: "Revenus Abonnés",
          desc: "Prépayé / Postpayé — certification des revenus.",
          long:
            "Reconstruction et certification des chiffres d'affaires des opérateurs selon une méthodologie éprouvée de commissariat aux comptes. Analyse de tous les types de transaction (rechargements, achats de packages, consommations, transferts, crédits perdus) et cohérence avec les crédits restants. Calcul des droits d'accise et micro-taxes, simulation de nouvelles taxes, analyse de la TVA collectée.",
        },
        {
          key: "tarif",
          name: "Vérification Tarifaire",
          desc: "Contrôle des tarifs réellement appliqués.",
          long:
            "Reconstruction des tarifs et frais réellement appliqués par les opérateurs pour toutes les transactions télécom et mobile money (prix à la minute, SMS, VAS, frais de transfert P2P ou cash out), comparés aux tarifs officiellement publiés.",
        },
        {
          key: "momo",
          name: "Mobile Money",
          desc: "Certification des revenus, y compris marchands.",
          long:
            "Reconstruction et certification des chiffres d'affaires. Analyse de tous les types de transaction (cash in, cash out, transferts, achats) et cohérence avec les crédits restants. Analyse du chiffre d'affaires et de la TVA collectée par tous les marchands, avec intégration à la Direction Générale des Impôts pour identifier les marchands non déclarés.",
        },
        {
          key: "roam",
          name: "Roaming",
          desc: "Revenus et coûts entrants / sortants.",
          long:
            "Reconstruction et certification des coûts de Roaming Out et revenus de Roaming In, par zone visitée et réseau d'origine. Analyse des tarifs entre opérateurs pour envisager la mise en place d'un roaming régional.",
        },
        {
          key: "search",
          name: "Recherches Avancées / Réquisitions Judiciaires",
          desc: "Recherches avancées et système centralisé de réquisitions.",
          long:
            "Permet aux utilisateurs autorisés de réaliser des recherches par numéro de téléphone, numéro de série du terminal ou cellule visitée. Utilisable dans le cadre des réquisitions judiciaires pour disposer en quelques minutes de toutes les informations les plus récentes (usages, terminaux, déplacements).",
        },
      ],
      principlesTitle: "Pourquoi cette architecture",
      principles: [
        { t: "Souveraineté numérique", d: "Le régulateur reprend le contrôle sur son marché télécom." },
        { t: "Indépendance vis-à-vis des opérateurs", d: "Fini la dépendance aux seules déclarations opérateurs." },
        { t: "Clé en main", d: "Conçue, déployée et maintenue par Snype/CIDES." },
        { t: "Time-to-value rapide", d: "Premiers résultats en moins d'un mois, déploiement complet en moins de 6 mois." },
        { t: "Haute disponibilité", d: "Installée dans le pays, redondance géographique." },
        { t: "Temps quasi-réel", d: "Collecte de données brutes directement depuis les plateformes techniques." },
        { t: "Traitement homogène", d: "Tous opérateurs, toutes technologies : Fixe / VoIP / 2G / 3G / 4G / 5G." },
        { t: "Auditable de bout en bout", d: "Jusqu'au niveau de l'abonné et de la transaction unitaire." },
        { t: "Historique reconstitué", d: "Reconstitution de données historiques sur 1 à 3 ans." },
        { t: "Non intrusif", d: "Aucun impact sur les réseaux des opérateurs." },
      ],
      revenueTitle: "Un investissement qui s'autofinance",
      revenueLead: "Un retour sur investissement direct et mesurable pour les finances publiques.",
      revenue: [
        { t: "Taxes d'interconnexion internationale", d: "Certification des volumes et fiabilisation de l'assiette." },
        { t: "Micro-taxes", d: "Activations SIM et transactions Mobile Money." },
        { t: "Homologation terminaux", d: "Frais d'homologation et redevances liées au CEIR." },
        { t: "Amendes fraude & non-conformité", d: "SimBox, contournement, non-respect des cahiers des charges." },
        { t: "Sous-déclarations", d: "Détection des sous-déclarations de chiffre d'affaires et de TVA." },
        { t: "Taxation des OTT", d: "Assiette et perception sur les acteurs internet internationaux." },
      ],
    },
    references: {
      eyebrow: "Marchés & Références",
      title: "Une présence de terrain, avec des réalisations concrètes et vérifiables.",
      items: [
        "Passeports de la République du Congo",
        "Carte d'identité nationale de la République du Congo",
        "Documents sécurisés officiels de la République Démocratique du Congo",
        "Carte de résident étranger de la République du Congo",
        "Timbres-poste pour plus de 15 pays",
        "Chèques pour la République Centrafricaine",
        "Visa d'immigration pour la République Centrafricaine",
        "Visa d'immigration pour la République du Congo",
      ],
    },
    finance: {
      eyebrow: "Financement",
      title: "Des mécanismes de financement adaptés aux États.",
      lead:
        "Fort de son expérience sur le continent africain, CIDES Invest & Trade Ltd a développé des outils de financement efficaces pour permettre aux gouvernements d'acquérir des solutions d'identification performantes, sans nécessité d'investir à l'avance des montants importants.",
      approachTitle: "Notre approche",
      approaches: [
        { t: "Approche des marchés", d: "Analyse fine des besoins de l'État, cadrage juridique et technique, gouvernance." },
        { t: "Mécanismes de financement", d: "Structures adaptées : DSP, BOT, financements structurés, autofinancement par la recette." },
        { t: "Présence géographique", d: "Plus d'une douzaine de pays d'intervention, avec une priorité historique sur l'Afrique." },
      ],
      mapTitle: "Présence internationale",
      mapCaption: "Plus d'une douzaine de pays servis — majoritairement sur le continent africain.",
    },
    contact: {
      eyebrow: "Contact",
      title: "Un projet à discuter ? Écrivez-nous.",
      subtitle:
        "Notre bureau échange en priorité avec les institutions publiques, régulateurs et organismes d'État. Nous répondons sous 48 heures ouvrées.",
      form: {
        name: "Nom",
        organization: "Organisation",
        country: "Pays",
        email: "Email professionnel",
        message: "Message",
        submit: "Envoyer le message",
        sending: "Envoi…",
        successTitle: "Message envoyé",
        successDesc: "Nous revenons vers vous sous 48 heures ouvrées.",
        errorTitle: "Envoi impossible",
        errorDesc: "Une erreur est survenue. Merci de réessayer ou d'écrire directement à management@cidesinvest.io.",
        required: "Champ requis",
      },
      coordinatesTitle: "Coordonnées",
      email: "Email",
      hq: "Siège social",
      hqAddress: "23 Woodvale Avenue, Giffnock, Glasgow, United Kingdom, G46 6RG",
      company: "CIDES Invest and Trade Limited — Company n° SC564447",
    },
    footer: {
      tagline: "Identité, traçabilité et souveraineté numérique pour les États.",
      rights: "Tous droits réservés.",
      nav: "Navigation",
      contact: "Contact",
      legal: "Mentions légales",
    },
  },

  en: {
    nav: {
      home: "Home",
      documents: "Secure Documents",
      telecom: "Telecom & Traceability",
      finance: "Markets & Financing",
      contact: "Contact",
      contactCta: "Contact us",
    },
    hero: {
      eyebrow: "Identity — Traceability — Sovereignty",
      title1: "Identity and traceability,",
      title2: "the pillars of national sovereignty.",
      subtitle:
        "For over two decades, CIDES has stood alongside States and regulators to design, secure and operate identification and traceability infrastructures — in more than a dozen countries, mostly across the African continent.",
      stat1: "20+ years of experience",
      stat2: "12+ countries served",
      stat3: "50+ years combined expertise",
      cta1: "Explore our activities",
      cta2: "Contact us",
    },
    about: {
      eyebrow: "Profile",
      title: "A discreet partner of sovereign States for over 20 years.",
      p1:
        "Founded in the early 2000s, CIDES Invest & Trade Ltd designs, secures and deploys identification and official-document solutions for States and public administrations.",
      p2:
        "Backed by a team whose combined experience exceeds 50 years in the sector, CIDES has delivered projects in more than a dozen countries, with a particularly strong historical footprint across the African continent.",
      p3:
        "Our expertise now spans the production of biometric identity documents through to the certification of telecom revenues and the digital sovereignty of regulators — two complementary sides of a single mission: giving our State partners total, reliable and auditable control over their critical data.",
      quote:
        "CIDES Invest has demonstrated its knowledge and success on the key files of applications for identification solutions.",
      pillar1Title: "Confidentiality",
      pillar1Desc: "Operations conducted with the discretion sovereign States require.",
      pillar2Title: "Sovereignty",
      pillar2Desc: "Solutions installed and maintained in-country, no foreign dependency.",
      pillar3Title: "Rigour",
      pillar3Desc: "Full auditability, from aggregated views down to a single transaction.",
    },
    documents: {
      eyebrow: "Secure Documents — Technology & Solutions",
      title: "Designing, producing and integrating secure official documents.",
      intro:
        "Adopting a modern identification system brings concrete, measurable benefits to any administration.",
      benefitsTitle: "Benefits for the administration",
      benefits: [
        "High-quality, secure and tamper-proof documents",
        "A modern system aligned with peer-administration standards",
        "Reinforced control over the issuance of every document to prevent fraud",
        "A reliable, flexible database enabling immediate and precise search",
        "Real-time statistics by category or theme",
        "Significant reduction in the physical handling of documents",
        "Accurate management of stocks and of the revenues generated by issuance",
        "The ability, over time, to connect the database to other administrations or ministries",
        "A scalable architecture, extendable to other applications or documents in the future",
        "A recognised improvement factor in the evaluation of public performance",
      ],
      methodTitle: "Our methodology",
      methodLead: "A proven, six-step process.",
      method: [
        { t: "Data acquisition", d: "Regulatory scoping and collection of primary sources." },
        { t: "Enrolment", d: "Biometric and administrative enrolment of citizens or users." },
        { t: "Verification", d: "Cross-checks and multi-criteria identity validation." },
        { t: "Deduplication", d: "Biometric (1:N) deduplication across the register." },
        { t: "Personalisation", d: "Secure media personalisation (laser, ink, chip)." },
        { t: "Issuance", d: "Traceable issuance chain with logistical and financial security." },
      ],
      supportTitle: "End-to-end support",
      supportDesc:
        "We support every project with training, maintenance, continuous support and consulting services at every stage of the process.",
      rangeTitle: "Our range",
      range: {
        cards: {
          title: "Cards",
          items: [
            "National ID Cards",
            "Resident Cards",
            "Driving licences",
            "Voter cards",
            "Insurance cards",
            "ID Badges",
          ],
        },
        passports: {
          title: "Passports",
          items: ["ICAO-compliant", "Biometric", "Machine-readable (MRZ)"],
        },
        secure: {
          title: "Secure Documents",
          items: ["Cheques", "Tax documents / stamps", "Visas", "Postage stamps"],
        },
      },
      productsTitle: "Reference visuals",
      specimenNote: "Images shown are specimens — 'SPECIMEN' mention preserved as a mark of integrity and legitimacy.",
      p1: { title: "Biometric passports", tag: "Ordinary · Service · Diplomatic" },
      p2: { title: "National identity cards", tag: "eID · Resident cards · Technical cards" },
      p3: { title: "Entry visas", tag: "Stickers · e-Visa · Border posts" },
      p4: { title: "Tax stamps", tag: "Tax · Tobacco · Beverages" },
      p5: { title: "Biometric driving licences", tag: "ID-1 format · Central personalisation" },
      p6: { title: "Other fiduciary documents", tag: "Civil records · Professional cards" },
    },
    telecom: {
      eyebrow: "Telecom & Traceability — Revenue Assurance",
      title: "Big Data & Revenue Assurance for telecom regulators.",
      subtitle:
        "A Big Data and Revenue Assurance solution — Telecom, Banking, Mobile Money and Betting.",
      lead:
        "As essential as secure identity, digital sovereignty today runs through mastery of telecom data. In partnership with Snype, CIDES deploys Big Data and Revenue Assurance solutions that give regulators direct, factual and auditable access to their telecom, financial and digital data.",
      partnerBadge: "In partnership with Snype",
      capabilitiesTitle: "What the regulator can do",
      capabilities: [
        "Subscriber base analysis, identification and KYC verification",
        "Voice, SMS and Data usage analysis",
        "QoS analysis on 2G/3G/4G/5G and radio coverage",
        "Certification of Prepaid/Postpaid revenues and applicable taxes (VAT, excise, micro-taxes)",
        "Verification of tariffs actually applied",
        "Certification of interconnection volumes and associated taxes",
        "Certification of Roaming revenues and costs",
        "Certification of Mobile Money revenues (including merchants)",
        "Fraud detection (interconnect bypass, SimBox, scams)",
        "OTT revenue analysis and associated taxation",
        "Handset control, customs duties, Central EIR",
        "Centralised system for judicial requests",
      ],
      extension:
        "Optional extensions: banking activities and currency control, corporate tax filings, online betting oversight.",
      modulesTitle: "13 modules, one platform",
      modules: [
        {
          key: "core",
          name: "Core",
          desc: "Technical foundation and real-time orchestration.",
          long:
            "The foundation of the solution. Handles file collection and processing, the database, archiving and all the tools for documentation, supervision, configuration and access-rights management.",
        },
        {
          key: "subs",
          name: "Subscriber Base",
          desc: "Mapping and KYC verification of the subscriber base.",
          long:
            "Analysis of the base (raw base, activations, terminations) and the functional base (truly active users), with geographic location and market share. Verification that subscribers are properly identified. Fraud control on fake ID documents. Fine computation. Automatic suspension of the impacted lines.",
        },
        {
          key: "usage",
          name: "Voice / SMS / Data Usage",
          desc: "Per-subscriber measurement and attribution.",
          long:
            "Analysis of Voice, SMS and Data usage, along with user bases and market share per operator, region by region. Ability to drill down by destination and by short number. Automatically detects new cells and new handsets, and checks consistency of information sent by the operators. These reference data then feed the geographic analyses and the comparison with valued prepaid, postpaid and roaming usage.",
        },
        {
          key: "fraud",
          name: "Fraud Detection",
          desc: "SimBox, interconnect bypass, scams.",
          long:
            "Detection of scam attempts and interconnect bypass. Integration with operators for immediate suspension. Integration with the CEIR for handset blocking. Location of the fraudsters.",
        },
        {
          key: "inter",
          name: "Voice / SMS Interconnection",
          desc: "Volume certification and associated taxes.",
          long:
            "Analysis of inbound/outbound interconnection, national/international, for each international carrier. Incident detection. Valuation of applicable taxes. Consistency control between operators, verifying that traffic leaving one really enters the other.",
        },
        {
          key: "ott",
          name: "OTT",
          desc: "Internet-actor revenues and applicable taxation.",
          long:
            "Analysis of data usage to reconstruct the user bases of the major internet actors (Netflix, Facebook, Google), in order to estimate their revenues and drive them to pay the taxes due (corporate tax, excise, VAT) on the basis of factual evidence.",
        },
        {
          key: "qos",
          name: "QoS",
          desc: "Service quality 2G/3G/4G/5G and radio coverage.",
          long:
            "Monitoring of the roll-out of 2G/3G/4G/5G cell sites and estimation of radio coverage, compared to the maps declared by the operators. Identification of white zones and of areas to target for drive tests. Analysis of the performance of cells and data connections, identification and qualification of incidents.",
        },
        {
          key: "ceir",
          name: "Handsets & CEIR",
          desc: "Handset control, customs duties, Central EIR.",
          long:
            "Analysis of the handset base, location of stolen, unhomologated or non-compliant handsets. Precise identification of users and of the location of first use. Synchronisation of operator EIRs, verification of effective blocking, interface with the customs system to identify untaxed handsets.",
        },
        {
          key: "rev",
          name: "Subscriber Revenues",
          desc: "Prepaid / Postpaid — revenue certification.",
          long:
            "Reconstruction and certification of operator revenues following a proven auditor methodology. Analysis of every transaction type (top-ups, package purchases, consumption, transfers, lost credits) and consistency with remaining credits. Calculation of excise and micro-taxes, simulation of new taxes, analysis of the VAT collected.",
        },
        {
          key: "tarif",
          name: "Tariff Verification",
          desc: "Control of tariffs actually applied.",
          long:
            "Reconstruction of the tariffs and fees actually applied by operators on all telecom and Mobile Money transactions (per-minute price, SMS, VAS, P2P transfer fees or cash-out fees), compared to the officially published tariffs.",
        },
        {
          key: "momo",
          name: "Mobile Money",
          desc: "Revenue certification, including merchants.",
          long:
            "Reconstruction and certification of revenues. Analysis of every transaction type (cash in, cash out, transfers, purchases) and consistency with remaining credits. Analysis of the revenues and VAT collected by every merchant, with integration to the tax authority to identify undeclared merchants.",
        },
        {
          key: "roam",
          name: "Roaming",
          desc: "Inbound / outbound revenues and costs.",
          long:
            "Reconstruction and certification of Roaming Out costs and Roaming In revenues, per visited zone and origin network. Analysis of inter-operator tariffs to enable the roll-out of a regional roaming scheme.",
        },
        {
          key: "search",
          name: "Advanced Search / Judicial Requests",
          desc: "Advanced search and centralised judicial requisition system.",
          long:
            "Enables authorised users to perform searches by phone number, handset serial number or visited cell. Usable in the context of judicial requisitions to obtain, in a few minutes, all the most recent information (usage, handsets, movements).",
        },
      ],
      principlesTitle: "Why this architecture",
      principles: [
        { t: "Digital sovereignty", d: "The regulator regains control over its telecom market." },
        { t: "Independence from operators", d: "No longer dependent solely on operator declarations." },
        { t: "Turnkey", d: "Designed, deployed and maintained by Snype/CIDES." },
        { t: "Fast time-to-value", d: "First results in less than a month, full deployment in under 6 months." },
        { t: "High availability", d: "Installed in-country with geographic redundancy." },
        { t: "Near real-time", d: "Raw data collection directly from technical platforms." },
        { t: "Homogeneous processing", d: "All operators, all technologies: Fixed / VoIP / 2G / 3G / 4G / 5G." },
        { t: "Fully auditable", d: "Down to the individual subscriber and transaction." },
        { t: "Historical replay", d: "Reconstruction of 1 to 3 years of historical data." },
        { t: "Non-intrusive", d: "Zero impact on operator networks." },
      ],
      revenueTitle: "A self-financing investment",
      revenueLead: "A direct, measurable return on investment for public finances.",
      revenue: [
        { t: "International interconnect taxes", d: "Volume certification and reinforcement of the taxable base." },
        { t: "Micro-taxes", d: "SIM activations and Mobile Money transactions." },
        { t: "Handset homologation", d: "Homologation fees and CEIR-related royalties." },
        { t: "Fraud & non-compliance fines", d: "SimBox, bypass, breaches of specifications." },
        { t: "Under-declarations", d: "Detection of revenue and VAT under-declarations." },
        { t: "OTT taxation", d: "Assessment and collection on international internet actors." },
      ],
    },
    references: {
      eyebrow: "Markets & References",
      title: "A field presence, with concrete and verifiable deliveries.",
      items: [
        "Passports of the Republic of the Congo",
        "National identity card of the Republic of the Congo",
        "Official secure documents of the Democratic Republic of the Congo",
        "Foreign resident card of the Republic of the Congo",
        "Postage stamps for more than 15 countries",
        "Cheques for the Central African Republic",
        "Immigration visa for the Central African Republic",
        "Immigration visa for the Republic of the Congo",
      ],
    },
    finance: {
      eyebrow: "Financing",
      title: "Financing mechanisms tailored to sovereign States.",
      lead:
        "Backed by its experience across the African continent, CIDES Invest & Trade Ltd has developed effective financing tools that allow governments to acquire high-performance identification solutions without having to commit large amounts up front.",
      approachTitle: "Our approach",
      approaches: [
        { t: "Market approach", d: "Fine analysis of State needs, legal and technical scoping, governance." },
        { t: "Financing mechanisms", d: "Adapted structures: PPP, BOT, structured finance, self-financing on revenue." },
        { t: "Geographic footprint", d: "More than a dozen countries served, with a historical focus on Africa." },
      ],
      mapTitle: "International footprint",
      mapCaption: "More than a dozen countries served — largely across the African continent.",
    },
    contact: {
      eyebrow: "Contact",
      title: "A project to discuss? Get in touch.",
      subtitle:
        "Our office engages primarily with public institutions, regulators and State bodies. We reply within 48 business hours.",
      form: {
        name: "Name",
        organization: "Organisation",
        country: "Country",
        email: "Business email",
        message: "Message",
        submit: "Send message",
        sending: "Sending…",
        successTitle: "Message sent",
        successDesc: "We will reply within 48 business hours.",
        errorTitle: "Unable to send",
        errorDesc: "An error occurred. Please try again or write directly to management@cidesinvest.io.",
        required: "Required field",
      },
      coordinatesTitle: "Coordinates",
      email: "Email",
      hq: "Registered office",
      hqAddress: "23 Woodvale Avenue, Giffnock, Glasgow, United Kingdom, G46 6RG",
      company: "CIDES Invest and Trade Limited — Company n° SC564447",
    },
    footer: {
      tagline: "Identity, traceability and digital sovereignty for States.",
      rights: "All rights reserved.",
      nav: "Navigation",
      contact: "Contact",
      legal: "Legal notice",
    },
  },
};
